// modules
import { createSelector } from 'reselect'

const activityLog = (state) => state.company.activityLog

export const startModal$ = createSelector(
  activityLog,
  ({ isStartModalOpen }) => isStartModalOpen
)

export const patientList$ = createSelector(
  activityLog,
  ({ patientList = [] }) => patientList
)
